import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { aboutUsSettingsApi } from "../services/aboutUsSettings.service";

import {
    ABOUTUSSETTINGS_REQUEST,
    aboutUsSettingsRequestSuccess,
    aboutUsSettingsRequestFailure,
    aboutUsSettingsRequest,
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST,
    aboutUsSettingsUpsertRequestFailure,
    aboutUsSettingsUpsertRequestSuccess,
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS,
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE
} from "../actions/aboutUsSettings.actions";

import {
    siteDataRequest
} from "../actions/sitedata.actions";

import {
    notificationSuccessShow,
    notificationErrorShow
} from "../actions/notification.actions";

export const aboutUsSettingsRequestEpic = action$ =>
    action$
        .ofType(ABOUTUSSETTINGS_REQUEST)
        .mergeMap((action) =>
            aboutUsSettingsApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(aboutUsSettingsRequestSuccess(response.aboutUsSettings)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(aboutUsSettingsRequestFailure(error.responseStatus.message))
                )
        );

export const aboutUsSettingsUpsertRequestEpic = action$ =>
    action$
        .ofType(ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST)
        .mergeMap((action) =>
            aboutUsSettingsApi
                .upsert(action.aboutUsSettings)
                .mergeMap(response => {
                    return concat$(Observable.of(aboutUsSettingsUpsertRequestSuccess(response.aboutUsSettings)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(aboutUsSettingsUpsertRequestFailure(error.responseStatus.message))
                )
        );

export const aboutUsSettingsUpsertRequestSuccessEpic = (action$, state$) =>
    action$
        .ofType(ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => aboutUsSettingsRequest());

export const aboutUsSettingsUpsertRequestSuccessNotificationEpic = (action$, state$) =>
    action$
        .ofType(ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => notificationSuccessShow("AboutUs settings saved"));

export const aboutUsSettingsUpsertRequestSuccessSiteDataEpic = (action$, state$) =>
    action$
        .ofType(ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => siteDataRequest());

export const aboutUsSettingsUpsertRequestErrorNotificationEpic = (action$, state$) =>
    action$
        .ofType(ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE)
        .map((action: any) => notificationErrorShow("Save failed: " + action.error));


// WEBPACK FOOTER //
// ./src/epics/aboutUsSettings.epic.ts